import {CircularProgress} from "@mui/material";
import Box from "@mui/material/Box";

const LoadingOverlay = () => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            position="fixed"
            top={0}
            left={0}
            width="100vw"
            height="100vh"
            zIndex={9999} // Ensures it stays above other elements
            bgcolor="rgba(255, 255, 255, 0.75)" // Optional: Dim the background with a slight white overlay
        >
            <CircularProgress color="primary" />
        </Box>
    );
};

export default LoadingOverlay;